import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { InitialState } from "state/InitialState";
import { PartnerInfoTypes } from "state/types/UserTypes";
import { UiActions } from "../UiActions";
import { PartnerGeneralActions } from "./PartnerGeneralActions";

// ----------------------------------------------------------------------

export const PartnerInfoActions = {};

// THUNKS
// ----------------------------------------------------------------------

PartnerInfoActions.savePartnerData = (partnerData, callback) => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    dispatch(PartnerInfoActions.start());

    let queueId = "PartnerInfo-" + Date.now();
    dispatch(UiActions.queue(queueId));

    let keys = [
      "personId",
      "accountHolder",
      "accountHolderLastName",
      "cpf",
      "rg",
      "pis",
      "accountType",
      "bankName",
      "bankCode",
      "agency",
      "pix",
      "pixType",
      "agencyDigit",
      "account",
      "accountDigit",
      "issueInvoice",
      "facebook",
      "instagram",
      "youtube",
      "blog",
      "cnpjHolder",
      "influencerDocumentStatus",
      "companyName",
      "nickCompanyName",
      "rgHolder"
    ],
        requestObject = {};

    for (let n of keys) {
      requestObject[n] = partnerData[n];
    }

    ExecuteRequest(
      GlamboxEndpoints.Partner.savePartner,
      requestObject,
      "PUT",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(PartnerInfoActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {
          dispatch(PartnerInfoActions.success(true));

          dispatch(PartnerGeneralActions.fetch(partnerData.access_token));

          if (callback) callback(response);

          dispatch(PartnerInfoActions.updateInfo(result));
        } else {

          // TODO: DESCOMENTAR
          // dispatch(PartnerInfoActions.error(error));
          // if (callback) callback(response, error);
        }
      }
    );
  };
};

PartnerInfoActions.saveSocialData = (partnerData, callback) => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    dispatch(PartnerInfoActions.start());

    let queueId = "PartnerInfo-" + Date.now();
    dispatch(UiActions.queue(queueId));

    let keys = [
      "personId",
      "facebook",
      "instagram",
      "youtube",
      "blog",
    ],
        requestObject = {};

    for (let n of keys) {
      requestObject[n] = partnerData[n];
    }

    ExecuteRequest(
      GlamboxEndpoints.Partner.saveSocial,
      requestObject,
      "PUT",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(PartnerInfoActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {
          dispatch(PartnerInfoActions.success(true));

          dispatch(PartnerGeneralActions.fetch(partnerData.access_token));

          if (callback) callback(response);

          dispatch(PartnerInfoActions.updateInfo(result));
        } else {

          // TODO: DESCOMENTAR
          // dispatch(PartnerInfoActions.error(error));
          // if (callback) callback(response, error);
        }
      }
    );
  };
};

PartnerInfoActions.fetch = () => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    dispatch(PartnerInfoActions.start());
    let queueId = "PartnerInfo-" + Date.now();
    dispatch(UiActions.queue(queueId));

    ExecuteRequest(
      GlamboxEndpoints.Partner.getPartnerInfo,
      null,
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(PartnerInfoActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {
          dispatch(PartnerInfoActions.success(true));

          dispatch(PartnerInfoActions.set(result[0]));
        } else {
          dispatch(
            PartnerInfoActions.error(
              (result && result.message)
                ? result.message
                : "Erro"
            )
          );

          dispatch(
            UiActions.publishSuccessAlert(
              (result && result.message)
                ? result.message
                : "Erro"
            )
          );
        }
      }
    );
  };
};

PartnerInfoActions.getCorrectInfoByInfluencerStatus = (result) =>{
  let normalGlampartnerResult = result.filter((infos)=>{
    return(infos.personalUse === true);
  });
  if(normalGlampartnerResult.length > 0){
    return normalGlampartnerResult[0];
  }else{
    return result.filter((infos)=>{
      return(infos.personalUse === false);
    })[0];
  }
}


PartnerInfoActions.start = () => {
  return (dispatch) => {
    dispatch(PartnerInfoActions.pending(true));
    dispatch(PartnerInfoActions.success(false));
    dispatch(PartnerInfoActions.error(null));
  };
};

// ACTIONS PURAS
// ----------------------------------------------------------------------

PartnerInfoActions.updateInfo = (partnerInfo) => ({
  partnerInfo: {
    data: partnerInfo,
    lastSync: Date.now()
  },
  type: PartnerInfoTypes.updateInfo
});

PartnerInfoActions.sync = () => ({
  partnerInfo: {
    lastSync: Date.now()
  },
  type: PartnerInfoTypes.sync
});

PartnerInfoActions.set = (partnerInfo) => ({
  partnerInfo: {
    data: partnerInfo,
    lastSync: Date.now()
  },
  type: PartnerInfoTypes.set
});

PartnerInfoActions.unset = () => ({
  partnerInfo: InitialState.createSyncObject(),
  type: PartnerInfoTypes.unset
});

PartnerInfoActions.success = (success) => ({
  partnerInfo: {
    success: (success === true)
  },
  type: PartnerInfoTypes.success
});

PartnerInfoActions.pending = (pending) => ({
  partnerInfo: {
    pending: (pending === true)
  },
  type: PartnerInfoTypes.pending
});

PartnerInfoActions.error = (error) => ({
  partnerInfo: {
    error
  },
  type: PartnerInfoTypes.error
});